import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, withRouter, useLocation } from "react-router-dom";
import { forgotPassword } from "../../Store/Actions/authActions";
import { FORGOT_PASSWORD_RESET } from "../../Store/Constants/authConstants";
import "./reset.scss";
import useForm from "../../hooks/login/useForm";
import validate from "../../validation/ForgotPasswordFormValidationRules";
import ButtonLink from "../Buttons/ButtonLink/ButtonLink";

function Login(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState("");
  const forgotpassworddata = useSelector((state) => state.forgotpassword);
  const [email, setEmail] = useState("");
  const [mailMessage, setMailMessage] = useState(false);

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();

  useEffect(() => {
    if (forgotpassworddata && forgotpassworddata.error) {
      setError(forgotpassworddata.error);
    }
  }, [forgotpassworddata]);

  useEffect(() => {
    if (
      forgotpassworddata &&
      forgotpassworddata.password &&
      forgotpassworddata.password.success
    ) {
      setMailMessage(true);
      setTimeout(() => {
        setMailMessage(false);
        forgotpassworddata.password.success = "";
        history.push("/login");
      }, 4000);
    }
  }, [forgotpassworddata]);

  const gotoLogin = () => {
    dispatch({ type: FORGOT_PASSWORD_RESET });
    history.push("/login");
  };

  useEffect(() => {
    setEmail(user.email);
  }, [props]);

  const onSubmit = (e) => {
    dispatch(forgotPassword(user.email));
  };
  const queryemail = query.get("email");
  const { handleSubmit, handleChange, errors, user } = useForm(
    onSubmit,
    validate,
    queryemail
  );
  const hideLogin = () => {
    if (props && props.isModal) {
      props.handleActive("signup");
    } else {
      history.push("/signup");
    }
  };
  return (
    <>
      <img
        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/logo.svg`}
        alt="logo"
        className="logo"
      />
      <h4 className="maintitle">Forgot Password</h4>
      <p className="titledesc">
        New User?
        <span>
          <span
            className="primarycolor pb-1 ml-2 dashedbottom"
            onClick={hideLogin}
          >
            Sign up for a new account
          </span>
        </span>
      </p>

      <form onSubmit={handleSubmit}>
        {errors && errors.email && <p className="error">{errors.email}</p>}
        {error && error.message && <p className="error">{error.message}</p>}
        <div>
          {mailMessage ? (
            <p className="text-success text-left">
              {forgotpassworddata &&
                forgotpassworddata.password &&
                forgotpassworddata.password &&
                forgotpassworddata.password.message}{" "}
            </p>
          ) : (
            ""
          )}
          <input
            type="text"
            className="form-control primaryinput mb-3"
            placeholder="Registered Email"
            value={user.email}
            name="email"
            autoComplete="on"
            onChange={handleChange}
          />
          <button type="submit" className="btn successbtn btn-block mt-3">
            Reset Password
          </button>
        </div>
      </form>
      <div className="my-3 d-flex align-items-start justify-content-end">
        <ButtonLink click={gotoLogin} title="Back to login" />
      </div>
    </>
  );
}

export default Login;
